export const OTP_ACTION_LOGIN = 'Login';
export const OTP_ACTION_DISABLE_2FA = 'Disable_2FA';
export const OTP_ACTION_EXECUTE_PAYROLL = 'Execute_Payroll';